import { render, staticRenderFns } from "./DataPreview.vue?vue&type=template&id=0a6d3974&scoped=true"
import script from "./DataPreview.vue?vue&type=script&lang=js"
export * from "./DataPreview.vue?vue&type=script&lang=js"
import style0 from "./DataPreview.vue?vue&type=style&index=0&id=0a6d3974&prod&lang=scss"
import style1 from "./DataPreview.vue?vue&type=style&index=1&id=0a6d3974&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6d3974",
  null
  
)

export default component.exports